import Label from 'components/form/Label/Label';
import { openNewTab } from 'helpers/domHelper';

const onClickGoToActionDetails = () => {
  openNewTab('https://smart.link/rbfe5mo56ankf');
};

export const getNotificationMessage = ({ getDefaultAnnotation, tradeline }) => {
  if (getDefaultAnnotation()?.paymentHistory?.paymentStreak) {
    return '6 month on-time payment streak! Nice job';
  } else if (
    getDefaultAnnotation()?.paymentHistory?.delinquentTradelineToCurrent
  ) {
    return 'Great job getting this current. Keep paying your bill on-time to improve your overall credit health';
  } else if (getDefaultAnnotation()?.creditUsage?.creditUsageOverLimit) {
    return 'You have used the card over the provided credit limit. We recommend you reduce this cards usage by $xxxx or more. Lenders like to see credit usage of 30% or lower';
  } else if (
    tradeline?.latestPayStatusEnum === 'COLLECTION' ||
    getDefaultAnnotation()?.collectionTradeline
  ) {
    return (
      <Label>
        Your account has overdue payments. Pay the minimum amount to avoid a
        charge-off going to collections. If the account is already in
        collections, check out our{' '}
        <span onClick={onClickGoToActionDetails} className="pointer underline">
          Collections Guide
        </span>{' '}
        for steps you can take to pay, settle or discharge the debt. Act as soon
        as possible to minimize the negative impact on your credit score
      </Label>
    );
  } else {
    return 'This account needs immediate attention';
  }
};
